export const companiesRequiredPhoneNumber: Array<string> = ["101030"];
